import call from "../../../../service/http";
import WorkExperienceConstants from "./WorkExperienceConstants";

export default {
  state: {
    experience: [],
  },
  mutations: {
    SET_WORK_EXPERIENCES: (state, payload) => {
      state.experience = payload;
    },
  },
  getters: {
    experience: (state) => state.experience,
  },
  actions: {
    getExperience: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("get", WorkExperienceConstants.experience)
        .then((res) => {
          commit("SET_WORK_EXPERIENCES", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    addWorkExperience: ({ commit, dispatch }, data) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("post", WorkExperienceConstants.experience, data)
        .then(() => {
          dispatch("getExperience");
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    removeExperience: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", WorkExperienceConstants.remove, payload)
        .then(() => {
          dispatch("getExperience");
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    updateWorkExperience: ({ dispatch, commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", WorkExperienceConstants.update, payload)
        .then(() => {
          dispatch("getExperience");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
  },
};
